<template>
    <v-container fluid>
        <v-row class="mt-5">
            <v-spacer />
            <v-img contain width="100" class="mt-5" :src="require('../assets/RepairSmart_White.png')" />
            <v-spacer />
        </v-row>
        <v-container fluid fill-height>
            <v-row class="mt-5" align-center justify-center>
                <v-col />
                <v-col cols="12" sm="6">
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Please Login</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field v-model="username" name="login"
                                              placeholder="Username" type="text" />
                                <v-text-field v-model="password" name="password"
                                              placeholder="Password" id="password" type="password" />
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn :loading="isLoading" :disabled="isLoading" @click="doLogin" color="primary">Login
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col />
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import {EventBus} from '../EventBus';
    import {AuthHttp} from "../http/auth";

    export default {
        name: "Login",
        data() {
            return {
                username: '',
                password: '',
                isLoading: false
            }
        },
        methods: {
            async doLogin() {
                if (this.username.length > 0 && this.password.length > 0) {
                    this.isLoading = true;
                    try {
                        const token = await AuthHttp.login(this.username, this.password);
                        await this.$store.dispatch('app/setAuthStatus', true);
                        await this.$store.dispatch('app/setToken', token.token);
                        EventBus.$emit('message', {message: `Sign in successful, let's get you started`, type:'success'});
                        await this.$router.replace('/');
                    } catch (e) {
                        EventBus.$emit('message', {message: e.message, type: 'error'});
                    } finally {
                        this.isLoading = false;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
